module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/linha-telefonica/linha-telefonica.component.css
// module id = ./src/app/linha-telefonica/linha-telefonica.component.css
// module chunks = main